import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: "courses",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "manage-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [],
});
